import React, { PropsWithChildren, createRef, useEffect } from 'react';
import Header from '../Header/Header.tsx';
import { useAppState } from '../../BikesAppState.tsx';

import './ModalContent.less';

const ModalContent = ({ children }: PropsWithChildren) => {
  const modalbodyRef = createRef<HTMLDivElement>();
  const { showFitAssistant } = useAppState();

  useEffect(() => {
    modalbodyRef?.current?.scrollTo(0, 0);
  }, [children]);

  return (
    <>
      <div className={`fit-assistant-modal on-top ${showFitAssistant ? 'wrapper-visible' : ''}`}>
        <header>
          <Header />
        </header>
        <section className="modal-content-section position-relative d-inline-block h-100" ref={modalbodyRef}>
          <div className="fit-assistant-modal-body pb-10">{children}</div>
        </section>
        <div id="moreInfoPortal"></div>
        <div id="buttonPortal"></div>
      </div>
    </>
  );
};

export default ModalContent;
